import { render, staticRenderFns } from "./AirportIndexView.vue?vue&type=template&id=2fafb458&scoped=true"
import script from "./AirportIndexView.vue?vue&type=script&lang=js"
export * from "./AirportIndexView.vue?vue&type=script&lang=js"
import style0 from "./AirportIndexView.vue?vue&type=style&index=0&id=2fafb458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fafb458",
  null
  
)

export default component.exports